import { render, staticRenderFns } from "./SettingsInputFile.vue?vue&type=template&id=893a38cc&scoped=true"
import script from "./SettingsInputFile.vue?vue&type=script&lang=js"
export * from "./SettingsInputFile.vue?vue&type=script&lang=js"
import style0 from "./SettingsInputFile.vue?vue&type=style&index=0&id=893a38cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893a38cc",
  null
  
)

export default component.exports